import React, { useMemo } from "react";
import { useSessionStore } from "../../lib/Store/sessionStore.component";
import { View, Text, FlatList } from "react-native";
import styles from "./SelectionFicheAgent.styles";
import FicheAgentItem from "./FicheAgentItem";
import { SelectionFicheAgentProps } from "./SelectionFicheAgent.types";

export default function SelectionFicheAgent({ navigation, withoutTitle = false }: SelectionFicheAgentProps) {
  const { getCurrentInfos } = useSessionStore();
  const { currentDatabase } = getCurrentInfos();

  const renderEmptyList = useMemo(() => (
    <View style={styles.emptyContainer}>
      <Text style={styles.emptyText}>
        Aucune profil disponible{'\n'}
        Veuillez vous reconnecter
      </Text>
    </View>
  ), []);

  return (
    <View style={styles.container}>
      {!withoutTitle && (<Text style={styles.titre}>Sélectionnez un profil</Text>)}
        <FlatList
          data={currentDatabase?.fichesAgent}
          keyExtractor={(item) => `${item.loginInfo.identifiant}`}
          renderItem={(({item, index}) => (
            <FicheAgentItem
              index={index}
              ficheAgent={item}
              navigation={navigation}
            />
          ))}
          ListEmptyComponent={renderEmptyList}
          showsVerticalScrollIndicator={false}
          testID="SC_FICHES_AGENT"
        />
    </View>
  );
}